export default __webpack_public_path__ + "static/media/new_allocation_plus.fb627e0b.svg";